import React from 'react';
import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import { CardComponent } from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import FusionChart from '@HomaHealth/ui-component-library/lib/_components/atoms/FusionCharts';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import type { CSSObject } from 'tss-react';

export interface SpendExpectedChartProps {
  goal: string;
  expected: string;
  maxFunding: string;
  spent: string;
  chartHeight?: number | string;
  chartWidth?: number | string;
  rootStyles?: CSSObject;
  title?: string;
}

const SpendExpectedChart: React.FC<SpendExpectedChartProps> = ({
  goal,
  expected,
  maxFunding,
  spent,
  chartWidth,
  chartHeight,
  rootStyles,
  title,
}) => {
  const dataSource = {
    chart: {
      theme: 'fusion',
      subCaptionFontSize: '11',
      numberPrefix: '$',
      chartBottomMargin: '25',
      showShadow: '0',
      showBorder: '0',
      baseFont: 'Inter',
      plotFillAlpha: '100',

      labelFontColor: patientAccessTheme.palette.text.highemphasis,
      labelFontSize: '12',
      labelFontBold: '0',
      labelPadding: '10',
      valueFontSize: '12px',
      valuePadding: '10',
      formatNumberScale: '0',
      yFormatNumberScale: '0',
      xFormatNumberScale: '0',
      showValues: '1',
      showTickValues: '1',
    },
    colorRange: {
      color: [
        {
          minValue: '0',
          maxValue: goal,
          code: '#00BDA5',
        },
        {
          minValue: goal,
          maxValue: expected,
          code: '#F5C26B',
        },
        {
          minValue: expected,
          maxValue: maxFunding,
          code: '#E08083',
        },
      ],
    },
    value: spent,
  };

  const useStyles = makeStyles()({
    visual: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
    labelContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      padding: '0.5rem 1rem',
      borderRadius: '4px',
      border: '1px solid #E5E9F0',
      marginTop: '0.5rem',
    },
    label: {
      height: '8px',
      width: '8px',
      borderRadius: '50%',
    },
    chartContainer: {
      display: 'flex',
      alignItems: 'flex-start',
      height: '380px',
      marginTop: '1rem',
      position: 'absolute',
      bottom: '0px',
      justifyContent: 'center',
      width: '100%',
    },
    rightLabelContainer: {
      position: 'relative',
      height: '300px',
      top: '10px',
      marginLeft: '-0.7rem',
    },
    labelRight: {
      position: 'absolute',
      fontSize: '13px',
      fontWeight: 500,

      width: '130px',
      textAlign: 'left',
      color: patientAccessTheme.palette.text.highemphasis,
    },
  });
  const { classes } = useStyles();

  const labels = [
    {
      label: 'Goal',
      color: '#00BDA5',
    },
    {
      label: 'Expected',
      color: '#F5C26B',
    },
    {
      label: 'Max Funding',
      color: '#E08083',
    },
    { label: 'Spend', color: '#000' },
  ];
  // const labelRight = [
  //   {
  //     label: '- 125% Max Funding',
  //     shift: 0,
  //   },
  //   {
  //     label: '- 100% Expected',
  //     shift: 25,
  //   },
  //   {
  //     label: '- 75% Goal',
  //     shift: 50,
  //   },
  //   {
  //     label: '- Spent',
  //     shift: 75,
  //   },
  // ];

  return (
    <CardComponent
      body={
        <Grid className={classes.visual}>
          <Grid className={classes.labelContainer}>
            {labels?.map((label) => (
              <Grid
                style={{ display: 'flex', alignItems: 'center', gap: '4px' }}
              >
                <div
                  style={{
                    backgroundColor: label?.color,
                  }}
                  className={classes.label}
                ></div>
                <Typography fontSize="12px">{label?.label}</Typography>
              </Grid>
            ))}
          </Grid>
          <Grid className={classes.chartContainer}>
            <FusionChart
              typeOfChart={'vbullet'}
              widthOfChart={chartWidth || '140'}
              heightOfChart={chartHeight || '300'}
              dataSource={dataSource}
            />
            {/* <div className={classes.rightLabelContainer}>
              {labelRight.map((label) => (
                <Typography
                  className={classes.labelRight}
                  style={{ top: `calc(-3% + ${label.shift}%)` }}
                >
                  {label.label}
                </Typography>
              ))}
            </div> */}
          </Grid>
        </Grid>
      }
      padding="8px"
      title={
        <Typography fontType="semiBold">
          {title ?? 'Spent vs Expected and Max Funding'}
        </Typography>
      }
      mainGridStyles={rootStyles}
    />
  );
};

export default SpendExpectedChart;
